import React, { useEffect } from 'react';
import { Col} from 'react-bootstrap';
import * as yup from 'yup';
import SmartField from '../../../../rhf/smartfield';
import { useWatch } from 'react-hook-form';

export const GetDeathValidationSchema = (formValues,lookupData) => {
    const base = {
        deathcircumstance: yup.string().required("*Required"),
        deathcircumstanceother: yup.string().when('deathcircumstance', {
            is: (val) => lookupData.deathcircumstances.filter(x => x.hasfollowup).map(x => x.id).includes(val),
            then: (schema) => schema.required('Required').typeError('Invalid'),
            otherwise: (schema) => schema.notRequired().nullable()
        }),
    }

    return base;
    
}

const DeathFields = ({register,errors,control,resetField,lookupdata}) => {
    const deathVal = useWatch({
        control: control,
        name: 'deathcircumstance'
    })

    const selectedDeathItem = lookupdata.deathcircumstances.find(item => item.id === deathVal);

    useEffect(() => {
        if(selectedDeathItem){
            if(!selectedDeathItem.hasfollowup){
                resetField('deathcircumstanceother',{defaultValue: ''});
            }
        }
        else{
            resetField('deathcircumstanceother',{defaultValue: ''});
        }
    },[selectedDeathItem,resetField])

    return(
        <>
            <Col xs={12}>
                <strong className="d-flex justify-content-center">Death Information</strong>
            </Col>
            <Col xs={12}>
                <SmartField
                    label='Death Circumstance'
                    name='deathcircumstance'
                    type='select'
                    style={{width: '100%',height: '30px'}}
                    options={lookupdata.deathcircumstances}
                    register={register}
                    errors={errors}
                />
            </Col>
            {
                selectedDeathItem?.hasfollowup
                &&
                    <Col xs={12}>
                        <SmartField
                            label='Death Circumstance (Other)'
                            name='deathcircumstanceother'
                            type='text'
                            style={{width: '100%'}}
                            register={register}
                            errors={errors}
                        />
                    </Col>
            }
            <Col xs={12}>
                <SmartField
                    label='Death determined to be due to abuse, neglect, or exploitation.'
                    name='abuseneglectexploitation'
                    type='checkbox'
                    register={register}
                    errors={errors}
                />
            </Col>
            <Col xs={12}>
                <SmartField
                    label='Death contributable to breakdown in 24 hour backup system.'
                    name='breakdownbackupsystem'
                    type='checkbox'
                    register={register}
                    errors={errors}
                />
            </Col>
        </>
    )
}

export default DeathFields;